<template>
  <section :id="computedId" :class="classWrapper">
    <header v-if="title || description" :class="classHeader">
      <component
        :is="titleTag"
        v-if="title"
        :class="classTitle"
        v-html="pageTitle"
      ></component>
      <p v-if="description" :class="classDescription" v-html="description"></p>
      <a
        :class="classClose"
        v-if="close"
        href="#"
        @click.prevent="$emit('close', 1)"
        title="Zamknij"
        ><Icon name="x"></Icon
      ></a>
    </header>
    <slot />
  </section>
</template>
<script>
import Page from "./Page";

export default {
  name: "Section",
  extends: Page,
  props: {
    titleTag: {
      type: String,
      default: "h3"
    },
    classPrefix: {
      type: String,
      default: "section"
    },
    close: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pageTitle() {
      return this.title;
    },
    classClose() {
      return `${this.classPrefix}__close`;
    }
  }
};
</script>
